export default "__VITE_ASSET__BM$hwLv2__"